import React from 'react';
import HeroTitleStyle from '@/styles/components/careers/button-style/_index.module.scss';
import { Formik, FormikControl, Form, InputError, InputStyle, Button, Checkbox, CustomButtons,  TEXT_STYLES_OPTIONS, useTranslation} from '@/imports-files/pages/career/customize-career-page';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ColorPickerf from '@/components/color-pickerf';

export function HeroTitle({formik, sidebar_section, customizeCareerAction, setFonts}){
  const {t} = useTranslation()
  return(<>
      <div className = {`${HeroTitleStyle.CustomButtons}`}>
      <label className = {`${HeroTitleStyle.CustomButtons__Title}`}>{t('career:styles:fonts')}</label>
        <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
          <label>{t('career:styles:font_family')}</label>
        </div>
        <div className={`${HeroTitleStyle.CustomButtons__Fields__Input}`}>
          <FormikControl
            control       =   "select"
            options       =   {TEXT_STYLES_OPTIONS.fontFamilies}
            name          =   {`career_font_style_attributes.font_family`}
            career        =   {`${HeroTitleStyle.CustomButtons__Select} CareerSelect`}
            formik        =   {formik}
            placeholder   =   "Arial"
            default       =  {formik.values.career_font_style_attributes.font_family}
            onChange      =   {(option) => customizeCareerAction.fontStyleChange(option, formik, 'font_family', 'font_style', setFonts)}
          />
        </div>

        {/* Hero Text */}
          <label className = {`${HeroTitleStyle.CustomButtons__Title}`}>
            {t('career:styles:hero_text')}:<br/>
          </label>
          <div className = {`${HeroTitleStyle.CustomButtons__Fields100}`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields}`}>
                <div className = {`${HeroTitleStyle.CustomButtons__Fields__LeftContent}`}>
                  <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                    <label>{t('career:styles:font_size')}</label>
                  </div>
                  <div className={`${HeroTitleStyle.CustomButtons__Fields__Input}`}>
                    <FormikControl
                      control       =   "select"
                      options       =   {customizeCareerAction.fontSizeOptions('hero_font_size', t)}
                      name          =   {`career_font_style_attributes.hero_font_size`}
                      career        =   {`${HeroTitleStyle.CustomButtons__Select} CareerSelect`}
                      formik        =   {formik}
                      placeholder   =   "24px"
                      default       =  {formik.values.career_font_style_attributes.hero_font_size}
                      onChange      =   {(option) => customizeCareerAction.fontStyleChange(option, formik, 'hero_font_size', 'font_style')}
                    />
                  </div>
                </div>
                <div className = {`${HeroTitleStyle.CustomButtons__Fields__RightContent}`}>
                    <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                      <label>{t('career:styles:font_color')}</label>
                    </div>
                    <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                      <ColorPickerf formik={formik} color={formik.values.career_font_style_attributes.hero_font_color}
                        handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'hero_font_color', 'font_style')}
                      />
                    </div>
                  </div>

              </div>
          </div>
          <div className = {`${HeroTitleStyle.CustomButtons__Fields100} mt20`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields}`}>
             <div className = {`${HeroTitleStyle.CustomButtons__Fields__OverlayBaseContainer}`}>
                    <div className = {`${HeroTitleStyle.CustomButtons__Fields__OverlayLabelContainer}`}>
                      <label>{t('career:styles:overlay')}</label>
                    </div>
                    <div className = {`${HeroTitleStyle.OverlayGuideDesign}`}>
                      <label>{t('career:styles:overlay_description')}</label>
                    </div>
                    <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                      <ColorPickerf formik={formik} color={formik.values.hero_section_attributes.overlay_hash}
                        handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'hero_background_overlay','overlay')}
                      />
                    </div>
                </div>
              </div>
          </div>

          {/* Colours Style1 */}
        <label className = {`${HeroTitleStyle.CustomButtons__Title}`}>{t('career:styles:colours')}</label>
        <div className = {`${HeroTitleStyle.CustomColourStyle}`}>
        <label>{t('career:styles:1:heading')} : <br/><span>{t('career:styles:1:description')}</span></label>
          <div className = {`${HeroTitleStyle.CustomButtons__Fields}`}>
            <div className = {`${HeroTitleStyle.CustomButtons__Fields__LeftContent}`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                <label>{t('career:styles:bg_color')}</label>
              </div>
              <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                <ColorPickerf formik={formik} color={formik.values.career_font_style_attributes.style_hash.style_1.background_color}
                  handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'style_1_background_color', 'font_style')}
                />
              </div>
            </div>
            <div className = {`${HeroTitleStyle.CustomButtons__Fields__RightContent}`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                <label>{t('career:styles:font_color')}</label>
              </div>
              <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                <ColorPickerf formik={formik} color={formik.values.career_font_style_attributes.style_hash.style_1.font_color}
                  handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'style_1_font_color', 'font_style')}
                />
              </div>
            </div>
          </div>

            {/* Colours Style2 */}
        <label className = {`${HeroTitleStyle.CustomButtons__Title}`}>{t('career:styles:2:heading')}: <br/><span>{t('career:styles:2:description')}</span></label>
          <div className = {`${HeroTitleStyle.CustomButtons__Fields}`}>
            <div className = {`${HeroTitleStyle.CustomButtons__Fields__LeftContent}`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                <label>{t('career:styles:bg_color')}</label>
              </div>
              <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                <ColorPickerf formik={formik} color={formik.values.career_font_style_attributes.style_hash.style_2.background_color}
                  handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'style_2_background_color', 'font_style')}
                />
              </div>
            </div>
            <div className = {`${HeroTitleStyle.CustomButtons__Fields__RightContent}`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                <label>{t('career:styles:font_color')}</label>
              </div>
              <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                <ColorPickerf formik={formik} color={formik.values.career_font_style_attributes.style_hash.style_2.font_color}
                  handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'style_2_font_color', 'font_style')}
                />
              </div>
            </div>
          </div>
          {/* Colours Style3 */}
          <label className = {`${HeroTitleStyle.CustomButtons__Title}`}>{t('career:styles:3:heading')}: <br/><span>{t('career:styles:3:description')}</span></label>
          <div className = {`${HeroTitleStyle.CustomButtons__Fields}`}>
            <div className = {`${HeroTitleStyle.CustomButtons__Fields__leftContent}`}>
              <div className = {`${HeroTitleStyle.CustomButtons__Fields__Label}`}>
                <label>{t('career:styles:font_color')}</label>
              </div>
              <div className= {`${HeroTitleStyle.CustomButtons__Fields__ColorInput}`}>
                <ColorPickerf formik={formik} color={formik.values.career_font_style_attributes.style_hash.style_3.font_color}
                  handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'style_3_font_color', 'font_style')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  </>)
}